module.exports = __webpack_public_path__ + "static/media/AI.6a7654ac.png";